export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";